// Groups a flat category list into top-level categories, each carrying its own
// sub-categories. Nesting is exactly one level deep — the API enforces that.
//
// A sub-category whose parent is not in the list (deleted, or cut off by a
// pagination limit) is kept as a top-level entry rather than dropped, so it can
// never silently disappear from the nav.
/** A category with no parent is a top-level one. */
export const isTopLevel = (category) => !category?.parentId;

export const groupCategories = (categories) => {
  const list = Array.isArray(categories) ? categories : [];
  const parents = list.filter((category) => !category?.parentId);
  const parentIds = new Set(parents.map((parent) => String(parent._id)));

  const childrenByParent = {};
  const orphans = [];
  list.forEach((category) => {
    if (!category?.parentId) return;
    const parentId = String(category.parentId);
    if (!parentIds.has(parentId)) {
      orphans.push(category);
      return;
    }
    if (!childrenByParent[parentId]) childrenByParent[parentId] = [];
    childrenByParent[parentId].push(category);
  });

  return [
    ...parents.map((parent) => ({
      ...parent,
      children: childrenByParent[String(parent._id)] || [],
    })),
    ...orphans.map((orphan) => ({ ...orphan, children: [] })),
  ];
};
